export default __webpack_public_path__ + "static/media/male-after.982d7d3e.jpg";